<div style="text-align: center; margin-top: 20vh">
  <!-- <ng-lottie [options]="lottieOptions" [width]="'100vw'" [height]="'40vh'"></ng-lottie> -->
  <lottie-player
    src="../../../assets/lottie/not-found.json"
    background="transparent"
    speed="1"
    style="width: 100vw; height: 40vh"
    loop
    autoplay
  >
  </lottie-player>
  <h2 style="margin-top: 50px">Page Not Found</h2>
  <a href="https://inforida.com">
    <img src="../../../assets/images/logo.svg" height="35" />
  </a>
</div>
